class UtilityResponsiveTable {
    constructor() {
        this.init();
    }

    init() {
        const tables = document.querySelectorAll('.wysiwyg table, table');
        
        for (const table of tables) {
            this.makeResponsive(table);
        }
    }

    makeResponsive(table) {
        const rows = Array.from(table.querySelectorAll('tbody tr, tr'));
        if (rows.length === 0) return;

        // Trouver la ligne d'en-tête réelle (ignorer les lignes avec uniquement des colspan/rowspan)
        let headerRow = null;
        let headerRowIndex = 0;

        for (let i = 0; i < rows.length; i++) {
            const row = rows[i];
            const cells = row.querySelectorAll('td, th');
            
            if (cells.length === 0) continue;

            // Vérifier si c'est une ligne d'en-tête (contient des cellules sans colspan ou avec colspan mais plusieurs cellules)
            const hasMultipleCells = cells.length > 1;
            const allCellsHaveColspan = Array.from(cells).every(cell => 
                cell.hasAttribute('colspan') && parseInt(cell.getAttribute('colspan') || '1') > 1
            );
            
            // Si la ligne a plusieurs cellules OU si elle n'a qu'une cellule mais sans colspan important, c'est probablement l'en-tête
            if (hasMultipleCells || !allCellsHaveColspan) {
                // Vérifier que ce n'est pas juste une ligne de titre avec un seul colspan
                const singleCellWithLargeColspan = cells.length === 1 && 
                    cells[0].hasAttribute('colspan') && 
                    parseInt(cells[0].getAttribute('colspan') || '1') > 2;
                
                if (!singleCellWithLargeColspan) {
                    headerRow = row;
                    headerRowIndex = i;
                    break;
                }
            }
        }

        if (!headerRow) return;

        const headerCells = headerRow.querySelectorAll('td, th');
        const headerTexts = Array.from(headerCells).map(cell => {
            const colspan = parseInt(cell.getAttribute('colspan') || '1');
            const text = cell.textContent.trim();
            return { text, colspan };
        });

        // Créer un tableau des labels en tenant compte des colspan
        const labels = [];
        for (const header of headerTexts) {
            for (let i = 0; i < header.colspan; i++) {
                labels.push(header.text);
            }
        }

        // Ajouter data-label à toutes les cellules des lignes suivantes
        for (let i = headerRowIndex + 1; i < rows.length; i++) {
            const row = rows[i];
            const cells = Array.from(row.querySelectorAll('td'));
            
            // Ignorer les lignes qui sont uniquement des titres avec colspan
            const isTitleRow = cells.length === 1 && 
                cells[0].hasAttribute('colspan') && 
                parseInt(cells[0].getAttribute('colspan') || '1') > 2;
            
            if (isTitleRow) continue;

            let labelIndex = 0;

            for (const cell of cells) {
                // Si la cellule a déjà un data-label, ne pas le modifier
                if (cell.hasAttribute('data-label')) {
                    const colspan = parseInt(cell.getAttribute('colspan') || '1');
                    labelIndex += colspan;
                    continue;
                }

                if (cell.hasAttribute('colspan')) {
                    const colspan = parseInt(cell.getAttribute('colspan') || '1');
                    if (labels[labelIndex]) {
                        cell.setAttribute('data-label', labels[labelIndex]);
                    }
                    labelIndex += colspan;
                } else if (cell.hasAttribute('rowspan')) {
                    // Pour rowspan, utiliser le label de la colonne actuelle
                    if (labels[labelIndex]) {
                        cell.setAttribute('data-label', labels[labelIndex]);
                    }
                    labelIndex++;
                } else {
                    if (labels[labelIndex]) {
                        cell.setAttribute('data-label', labels[labelIndex]);
                    }
                    labelIndex++;
                }
            }
        }
    }

    static load() {
        new UtilityResponsiveTable();
    }
}

document.addEventListener('DOMContentLoaded', () => {
    UtilityResponsiveTable.load();
});

// Réinitialiser lors des transitions de page (pour les SPAs)
document.addEventListener('page-transition-complete', () => {
    UtilityResponsiveTable.load();
});

